/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import {
    Component,
    Injectable,
    OnDestroy,
    Type,
} from '@angular/core';

import { Subject } from 'rxjs';
import { CinematicService } from 'ng/modules/cinematic/services/cinematic.service';
import { VsLogCinematicComponent }
    from '../components/vs-log-cinematic/vs-log-cinematic.component';

/**
 * ID for Log Recommendation Dialog.
 */
const VS_LOG_CINEMATIC_ID = 'vs-log-cinematic';

/**
 * @description
 *     Service handling cinematic log functionality for the single entry log cinematic view.
 * @author Zhiqian Liu
 */
@Injectable()
export class VsLogCinematicService implements OnDestroy {
    public logCinematicCloseSubject$ = new Subject<void>();

    constructor(
        private readonly cinematicService: CinematicService,
    ) {}

    /**
     * Open a log cinematic.
     */
    public openCinematic(): void {
        this.cinematicService.add({
            id: VS_LOG_CINEMATIC_ID,
            component: VsLogCinematicComponent as Type<Component>,
            componentProps: {
                onClose: () => this.closeCinematic(),
            },
        });
    }

    /**
     * Close the log cinematic view.
     */
    public closeCinematic(): void {
        this.cinematicService.remove(VS_LOG_CINEMATIC_ID);
        this.logCinematicCloseSubject$.next();
    }

    /**
     * Check if the log cinematic view is open.
     */
    public isOpen(): boolean {
        return this.cinematicService.has(VS_LOG_CINEMATIC_ID);
    }

    /** @override */
    public ngOnDestroy(): void {
        this.logCinematicCloseSubject$.complete();
    }
}
